import React from 'react'
import { TooltipWrapper } from 'uiComponents/tooltip.new'
import './chipList.scss'
import { useTranslation } from 'translations'

interface ChipListProps {
    items: string[]
    limit?: number
    emptyText: string
}

export const ChipList: React.FC<ChipListProps> = ({ items, limit = 3, emptyText }) => {
    const { t } = useTranslation()

    if (!items.length) {
        return <span className="service-apps-chip-empty">{emptyText}</span>
    }

    const shown = items.slice(0, limit)
    const hidden = items.slice(limit)

    return (
        <div className="service-apps-chip-list">
            {shown.map((item) => (
                <span key={item} className="service-apps-chip" title={item}>
                    {item}
                </span>
            ))}
            {!!hidden.length && (
                <TooltipWrapper text={hidden.join(', ')} position="top" className="service-apps-chip-more-wrapper">
                    <span className="service-apps-chip-more">
                        {t('settings.personalSettings.serviceApps.chipList.more', { amount: hidden.length })}
                    </span>
                </TooltipWrapper>
            )}
        </div>
    )
}
